export default {
    SET_ADDITIONAL_LOCATION(state, additionalLocations) {
        state.additionalLocations = additionalLocations
    },
    SET_LOCATION_TYPE(state, locationTypes) {
        state.locationTypes = locationTypes
    }
}